import type { PolicyComparator } from '@policyvision/contracts';

import { Client } from '@/common/services/Client';

export async function fetchComparator(
  renewalUuid: string,
): Promise<PolicyComparator> {
  const response = await Client.get<PolicyComparator>({
    endpoint: `/comparator/${renewalUuid}`,
  });

  return response.data;
}
